import { render, staticRenderFns } from "./DocumentSign.vue?vue&type=template&id=038a4cfe&scoped=true&"
import script from "./DocumentSign.vue?vue&type=script&lang=js&"
export * from "./DocumentSign.vue?vue&type=script&lang=js&"
import style0 from "./DocumentSign.vue?vue&type=style&index=0&id=038a4cfe&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038a4cfe",
  null
  
)

export default component.exports